import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS =
  'product.notOnStock.delivery'

/*
 * possible values:
 * export const DELIVERY_3_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.3`
 * export const DELIVERY_3_5_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.3_5`
 * export const DELIVERY_5_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.5`
 * export const DELIVERY_5_7_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.5_7`
 * export const DELIVERY_7_10_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.7_10`
 * export const DELIVERY_10_14_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.10_14`
 * export const DELIVERY_20_30_DAYS = `${PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS}.20_30`
 */

/**
 * message key contains number of days, this extracts it from the string.
 */
const getDaysWillBeDelivered = (message: string): string => {
  const days = message.split('.').at(-1)

  return days?.replace('_', '-') ?? ''
}

/**
 * gets a string of how many days till delivery from message
 * @example
 * product.notOnStock.delivery.3_5 => 3-5
 * product.notOnStock.delivery.3 => 3
 * product.notOnStock.delivery.5_7 => 5-7
 * product.notOnStock.delivery.7_10 => 7-10
 */
export const productAccessorGetOutOfStockMessageDays = (
  product: PimProductV11,
): string => {
  const notOnStockMessage = product.out_of_stock_message

  if (!notOnStockMessage) {
    return ''
  }

  return getDaysWillBeDelivered(notOnStockMessage)
}
